<app-modal-header>
  <div class="flex w-full items-center justify-between">
    <div class="flex items-center">
      <svg-icon
        src="assets/icons/icon-systematic.svg"
        alt="'sistematica.titulo-sistematica' | translate"
        class="my-1 w-8 text-modules-pedagogical-900"
      ></svg-icon>
      <div translate class="ml-2 text-lg font-semibold text-modules-pedagogical-900" translate>
        sistematica.titulo-sistematica
      </div>
    </div>
  </div>
</app-modal-header>
<div app-modal-content class="z-0 h-[90vh] w-[95vw] p-0!">
  @if (
    {
      activated: activated(),
      loading: loading(),
      systematics: dataSystematic$ | async,
    };
    as data
  ) {
    @if (!data.loading && !!data.activated) {
      <app-sidenav-group class="h-full! w-full!">
        <ng-template app-sidenav-start [opened]="true" panelWidth="350px">
          <div class="flex h-full flex-col gap-4 overflow-y-auto bg-base-whisper-500 p-4">
            <ng-container *isAllow="[20, 40]">
              <button
                (click)="onNewSystematic()"
                app-flat-button
                class="w-full bg-modules-pedagogical-800 py-3 text-white transition-all hover:bg-modules-pedagogical-900"
              >
                <div class="flex items-center justify-center gap-2">
                  <svg-icon src="assets/icons/icon-plus.svg" class="w-5 text-white"></svg-icon>
                  <span class="font-semibold uppercase" translate>sistematica.novo</span>
                </div>
              </button>

              <hr class="border-gray-200" />
            </ng-container>

            @for (item of data.systematics; track item.id) {
              <div
                (click)="systematicCtrl.setValue(item)"
                class="flex cursor-pointer flex-col gap-1 rounded-lg p-4 shadow-sm transition-colors"
                [ngClass]="
                  systematicCtrl.value?.id === item.id
                    ? 'bg-modules-pedagogical-500 text-white'
                    : 'bg-white text-gray-800 hover:bg-modules-pedagogical-50'
                "
              >
                <div class="font-semibold">{{ item.title }}</div>
                <div
                  class="text-xs"
                  [ngClass]="systematicCtrl.value?.id === item.id ? 'text-modules-pedagogical-50' : 'text-gray-500'"
                >
                  {{ 'sistematica.periodo' | translate }} {{ item.date_start | date: 'dd/MM/yyy' }}
                  {{ 'sistematica.ate' | translate }}
                  {{ item.date_end | date: 'dd/MM/yyy' }}
                </div>
              </div>
            }
          </div>
        </ng-template>

        <ng-template app-sidenav-outer>
          <div class="flex h-full flex-col bg-white">
            <!-- Cabeçalho Fixo -->
            <div class="flex flex-col gap-6 p-8 pb-4">
              <div class="flex items-start justify-between">
                <div class="flex flex-col gap-3 overflow-hidden">
                  <h1 class="truncate text-3xl font-bold text-gray-900" app-tooltip [tooltip]="data.activated?.title">
                    {{ data.activated?.title }}
                  </h1>
                  <div class="flex items-center gap-2 text-sm text-gray-500">
                    <svg-icon src="assets/icons/icon-calendar.svg" class="w-5 text-modules-pedagogical-500"></svg-icon>
                    <span class="font-medium">
                      {{ data.activated?.date_start | date: 'dd/MM/yyyy' }}
                      <span class="mx-1 text-gray-400" translate>sistematica.ate</span>
                      {{ data.activated?.date_end | date: 'dd/MM/yyyy' }}
                    </span>
                  </div>
                </div>

                <div class="flex items-center gap-3" *isAllow="[20, 40]">
                  <button
                    (click)="onEditSystematic()"
                    app-icon-button
                    app-tooltip
                    [tooltip]="'geral.editar' | translate"
                    class="grid h-10 w-10 place-items-center border-2 border-gray-300 text-gray-500 transition-all hover:border-amber-500 hover:bg-amber-500 hover:text-white rounded-full!"
                  >
                    <svg-icon src="assets/icons/icon-edit.svg" class="w-5"></svg-icon>
                  </button>
                  <button
                    (click)="onDeleteSystematic()"
                    app-icon-button
                    app-tooltip
                    [tooltip]="'geral.excluir' | translate"
                    class="grid h-10 w-10 place-items-center border-2 border-gray-300 text-gray-500 transition-all hover:border-base-status-danger hover:bg-base-status-danger hover:text-white rounded-full!"
                  >
                    <svg-icon src="assets/icons/icon-trash-2.svg" class="w-5"></svg-icon>
                  </button>
                </div>
              </div>

              <!-- Seção de Turmas -->
              @if (data.activated?.groups?.length) {
                <div class="relative flex flex-col gap-2">
                  <div class="flex items-center justify-between">
                    <span class="text-[10px] font-bold uppercase tracking-widest text-gray-400" translate
                      >sistematica.turmas</span
                    >
                    @if (groupContainer.scrollHeight > 26) {
                      <button
                        (click)="isGroupsExpanded.set(!isGroupsExpanded())"
                        class="flex items-center gap-1 text-xs font-semibold text-modules-pedagogical-500 transition-colors hover:text-modules-pedagogical-600"
                      >
                        <span>{{
                          isGroupsExpanded() ? ('geral.ver-menos' | translate) : ('geral.ver-todos' | translate)
                        }}</span>
                        <svg-icon
                          [src]="
                            isGroupsExpanded() ? 'assets/icons/icon-arrow-up.svg' : 'assets/icons/icon-arrow-down.svg'
                          "
                          class="w-3"
                        ></svg-icon>
                      </button>
                    }
                  </div>

                  <div #groupContainer class="flex flex-wrap gap-2 overflow-hidden max-h-[26px]">
                    @for (group of data.activated?.groups; track group.id) {
                      <span
                        class="whitespace-nowrap rounded-full border border-modules-pedagogical-100 bg-modules-pedagogical-50 px-3 py-1 text-xs font-semibold text-modules-pedagogical-700"
                      >
                        {{ group.adems_id ? group.descricao : group.cod_turma }}
                      </span>
                    }
                  </div>

                  @if (isGroupsExpanded()) {
                    <div
                      class="absolute left-0 top-full z-50 mt-2 flex max-h-60 w-full flex-wrap gap-2 overflow-y-auto rounded-xl border border-gray-200 bg-white p-4 shadow-xl animate-in fade-in zoom-in duration-200"
                    >
                      @for (group of data.activated?.groups; track group.id) {
                        <span
                          class="whitespace-nowrap rounded-full border border-modules-pedagogical-100 bg-modules-pedagogical-50 px-3 py-1 text-xs font-semibold text-modules-pedagogical-700"
                        >
                          {{ group.adems_id ? group.descricao : group.cod_turma }}
                        </span>
                      }
                    </div>
                  }
                </div>
              }

              <!-- Abas de Conteúdo -->
              @if (data.activated?.attachments?.length) {
                <div class="flex w-full items-center gap-2 border-b border-gray-100 overflow-x-auto no-scrollbar">
                  @for (attachment of data.activated?.attachments; track attachment.id) {
                    <button
                      (click)="onOpenAttachment(attachment)"
                      class="flex cursor-pointer items-center gap-3 whitespace-nowrap px-4 py-3 transition-all relative group"
                      [ngClass]="
                        dataViewer()?.name === attachment.title
                          ? 'text-modules-pedagogical-600'
                          : 'text-gray-500 hover:text-gray-700'
                      "
                    >
                      <svg-icon class="w-5" [src]="icon(attachment.extension)"></svg-icon>
                      <span class="text-sm font-semibold">{{ attachment.title }}</span>

                      @if (dataViewer()?.name === attachment.title) {
                        <div
                          class="absolute bottom-0 left-0 h-1 w-full rounded-t-full bg-modules-pedagogical-500"
                        ></div>
                      } @else {
                        <div
                          class="absolute bottom-0 left-0 h-1 w-0 rounded-t-full bg-gray-200 transition-all group-hover:w-full"
                        ></div>
                      }
                    </button>
                  }
                </div>
              }
            </div>

            <!-- Conteúdo -->
            <div class="flex grow flex-col gap-6 overflow-y-auto p-8 pt-0 no-scrollbar">
              <div
                class="relative min-h-[500px] w-full grow rounded-2xl border border-gray-200 bg-gray-50 p-2 shadow-inner"
              >
                <app-file-viewer [data]="dataViewer()"></app-file-viewer>
              </div>
            </div>
          </div>
        </ng-template>
      </app-sidenav-group>
    } @else if (!data.loading && !data.activated) {
      <div class="flex h-full w-full flex-col items-center justify-center gap-4">
        <app-jumbotron>
          <span>
            {{ 'sistematica.lista-vazia' | translate }}
          </span>
          <ng-container *isAllow="[20, 40]">
            <button
              (click)="onNewSystematic()"
              app-flat-button
              class="bg-modules-pedagogical-500 mt-2 px-6 py-3 font-semibold uppercase text-white transition-all hover:bg-modules-pedagogical-600"
              translate
            >
              sistematica.novo
            </button>
          </ng-container>
        </app-jumbotron>
      </div>
    } @else {
      <div class="h-full w-full">
        <app-skeleton />
      </div>
    }
  }
</div>
